// extracted by mini-css-extract-plugin
export var numpadContainer = "_o1-1";
export var phoneButton = "_o1-0";